import { toast, ToastContent } from "react-toastify";

export const toastSuccess = (props: { message: ToastContent<string> }) => {
  toast.success(props.message, {
    position: "top-center",
    autoClose: 5000,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false
  });
};

export const toastError = (props: { message: ToastContent<string> }) => {
  toast.error(props.message);
};
